import React from "react";
import {NavLink} from "react-router-dom";
import ContentBox from "../../../../../../components/content-box/ContentBox";
import PageActions from "../../../../../base/PageActions";
import Breadcrumbs from "../../../../../../components/breadcrumbs/Breadcrumbs";
import _image_service from "../../../../../../services/ImageService";
import '../../../../../styles/Common.scss';
import '../../WorldPages.scss';
import './MagicItemsPage.scss';

interface MagicItemsPageProps {
}

const MagicItemsPage = (props: MagicItemsPageProps) => {

    const page: PageActions = new PageActions({
        title: `Casarok: Magic Items - Chase the Fox`,
        description: "Learn about the various magical items crafted to help the people of Casarok!",
        keywords: ["casarok", "magic", "magic compendium", "magic item", "magical", "magical item", "magic ward", "magic shield", "mage-tech", "magitech"],
        imgSrc: `chase/world/magic/items/amulet.png`,
        url: `world/magic/items`
    });

    return page.generateMetaContent(
        <>
            <ContentBox header="Magical Items">
                <Breadcrumbs path={page.getUrl()}/>
                <div className="world-page-static">
                    <img className="magic-item-pic right"
                         src={_image_service.getCdnImageSrc(`chase/world/magic/items/amulet.png`)}
                         alt="A green pendant with a red rune inside"
                         title="Chase's magic pendant, an example of a magical item found in Casarok"/>
                    <p>
                        Due to the volatility of magic, scholars have always sought ways to capture its benefits while
                        limiting some of
                        the <NavLink className="world-link" to="/world/magic/afflictions">drawbacks</NavLink>. Various
                        types of items were developed through different manner of enchantment to aid the people of
                        Casarok in using magic. Such items are divided into conduits and foci.
                    </p>
                    <p>
                        <strong>Conduits</strong> are magical items that do not require the user to cast the spell
                        imprinted on the item to gain its benefit. This prevents the need for the wielder to use their
                        own mana to cast the spell. The user then no longer needs to worry about the costs associated
                        with using magic. The drawback to this method is that the item has a limited amount, duration,
                        or power of the spell enchanted onto it.
                    </p>
                    <span>Types of conduits include</span>
                    <ul className="spaced">
                        <li><NavLink className="world-link" to="bulletguard">Bulletguard</NavLink></li>
                        <li><NavLink className="world-link" to="mage-tech">Mage-tech</NavLink></li>
                        <li><NavLink className="world-link" to="ward">Ward</NavLink></li>
                    </ul>
                    <p>
                        A <strong>focus</strong> is an item enchanted in a way that helps a magic user cast spells. The
                        user must have the knowledge in magic needed to cast spells on their own in order to use a
                        focus. The focus can amplify the spell power of the user, reduce the necessary use of their own
                        mana when casting the spell, provide access to a powerful spell that cannot be cast otherwise,
                        or any other number of potential benefits. The drawback of using a focus depends on the effect
                        that it provides.
                    </p>
                    <span>Types of foci include</span>
                    <ul className="spaced">
                        <li><NavLink className="world-link" to="amulet">Amulet</NavLink></li>
                        <li><NavLink className="world-link" to="runestone">Runestone</NavLink></li>
                        <li><NavLink className="world-link" to="tome">Tome</NavLink></li>
                    </ul>
                </div>
            </ContentBox>
        </>
    );
}

export default MagicItemsPage;